import { StoreFilter, VariantRestrictionCondition } from "./parse-variant-restrictions";

/**
 * Persists reviewed variant restrictions for a category. Mirrors the grouped
 * shape the CSV upload builds (owa-backend variant_restriction_group /
 * _group_store / _rule) so it can reuse the same repositories. Like the CSV
 * path, this replaces all restrictions for the category.
 */
export const RoutePostMerchflowSaveVariantRestrictions = "/merchflow/save-variant-restrictions";

export interface SaveVariantRestrictionRule {
  /** One or more variants, backend-joined as "A | B". */
  variant: string;
  /** Bay targeting, e.g. "1 | 2". */
  bay_number_rule: string;
  /** Shelf targeting: a number, "Top", "Top + N", "Bottom", or "Bottom - N". */
  shelf_rule: string;
  condition: VariantRestrictionCondition;
}

export interface SaveVariantRestrictionGroup {
  /** Group code (backend `variant_group_id`); joins rules to their store set. */
  variant_group_id: string;
  store_codes: string[];
  /** Optional rule-based store selection (e.g. by bay size), unioned with codes. */
  store_filter?: StoreFilter;
  rules: SaveVariantRestrictionRule[];
}

export interface PayloadPostMerchflowSaveVariantRestrictions {
  category_id: string;
  groups: SaveVariantRestrictionGroup[];
}

export interface ResponsePostMerchflowSaveVariantRestrictions {
  message: string;
}
